import { useQuery, useMutation } from 'react-query';
import queryGetOrganizations from './queries/getOrganizations';
import queryGetOrganization from './queries/getOrganization';
import queryGetAlertReceivers from './queries/getAlertReceivers';
import queryGetSimAlerts from './queries/getSimAlerts';
import queryCheckRegistrationNumber from './queries/checkRegistrationNumber';
import queryGetOrganizationSimOffers from './queries/getOrganizationSimOffers';
import mutationUpdateSubDomain from './mutations/updateSubDomain';
import mutationUpdateOrganizationBrand from './mutations/updateOrganizationBrand';
import mutationAddOrganization from './mutations/addOrganization';
import mutationUpdateOrganization from './mutations/updateOrganization';
import mutationDeleteAlertReceivers from './mutations/deleteAlertReceivers';
import mutationSimDeleteAlertReceivers from './mutations/deleteSimAlertReceivers';
import mutationAddNewPosEmails from './mutations/addNewPosEmails';
import mutationAddSimEmails from './mutations/addSimEmails';
import mutationUpdateSimAlertsSettings from './mutations/updateSimAlertsSettings';
import mutationUpdateOrganizationType from './mutations/updateOrganizationType';
import mutationUpdateSimOffers from './mutations/updateSimOffers';
import mutationCreateOrganizationPort from './mutations/createOrganizationPort';

const actionsOrganizations = {
    // Getters
    // get one organization
    getOrganization: (organizationId, enabled = true) => useQuery(queryGetOrganization(organizationId, enabled)),
    // get all organizations
    getOrganizations: (params, enabled) => useQuery(queryGetOrganizations(params, enabled)),
    // get Sim alert receivers
    getAlertReceivers: (organizationId, enabled) => useQuery(queryGetAlertReceivers(organizationId, enabled)),
    // get sim alerts
    getSimAlerts: (organizationId, enabled) => useQuery(queryGetSimAlerts(organizationId, enabled)),
    // get organization sim offers
    getOrganizationSimOffers: (params, enabled = true) => useQuery(queryGetOrganizationSimOffers(params, enabled)),
    // check organization registration number
    checkRegistrationNumber: (registrationNumber, enabled = true) => useQuery(queryCheckRegistrationNumber(registrationNumber, enabled)),

    // Mutations
    // update Organization
    updateOrganization: (onSuccess, onError) => useMutation(mutationUpdateOrganization(onSuccess, onError)),
    // update subdomain
    updateSubDomain: (onSuccess, onError) => useMutation(mutationUpdateSubDomain(onSuccess, onError)),
    // add organization
    addOrganization: (onSuccess, onError) => useMutation(mutationAddOrganization(onSuccess, onError)),
    // update organization brand
    updateOrganizationBrand: (onSuccess, onError) => useMutation(mutationUpdateOrganizationBrand(onSuccess, onError)),
    // delete alert receivers
    deleteAlertReceivers: (onSuccess, onError) => useMutation(mutationDeleteAlertReceivers(onSuccess, onError)),
    // delete sim alerts receivers
    deleteSimAlertReceivers: (onSuccess, onError) => useMutation(mutationSimDeleteAlertReceivers(onSuccess, onError)),
    // add new pos emails
    addNewPosEmails: (onSuccess, onError) => useMutation(mutationAddNewPosEmails(onSuccess, onError)),
    // add sim emails
    addSimEmails: (onSuccess, onError) => useMutation(mutationAddSimEmails(onSuccess, onError)),
    // update simAlerts settings
    updateSimAlertsSettings: (onSuccess, onError) => useMutation(mutationUpdateSimAlertsSettings(onSuccess, onError)),
    // update organization type
    updateOrganizationType: (onSuccess, onError) => useMutation(mutationUpdateOrganizationType(onSuccess, onError)),
    // update sim offers
    updateSimOffers: (onSuccess, onError) => useMutation(mutationUpdateSimOffers(onSuccess, onError)),
    // create organization port
    createOrganizationPort: (onSuccess, onError) => useMutation(mutationCreateOrganizationPort(onSuccess, onError))

};

export default actionsOrganizations;